import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

const OpenDoorHeader = ({ companyName, onBack }) => (
  <>
    <Link
      component='button'
      type='button'
      underline='hover'
      variant='body2'
      fontWeight={600}
      onClick={onBack}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        border: 0,
        background: 'none',
        cursor: 'pointer',
        p: 0,
        mb: 2.5,
        color: 'primary.main',
      }}
    >
      <ArrowBackIcon sx={{ fontSize: 16 }} />
      Back to actions
    </Link>

    <Box display='flex' alignItems='flex-start' justifyContent='space-between' gap={2} mb={3} flexWrap='wrap'>
      <Box>
        <Box display='flex' alignItems='center' gap={1.25} mb={0.75}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              bgcolor: '#e8f5e9',
              color: '#2e7d32',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <PeopleAltOutlinedIcon sx={{ fontSize: 32 }} />
          </Box>
          <Box>
            <Typography variant='h5' fontWeight={700}>
              Open a door
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 720, lineHeight: 1.6 }}>
              Fill out the information in section 1 below. We&apos;ll craft a personalized introduction based
              on all relevant data we have about {companyName} plus AI research into your prospect.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  </>
);

export default OpenDoorHeader;
